import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { baseUrl } from "../../../../Baseurl/Baseurl";
import { toast } from "react-toastify";
import axios, { AxiosError } from 'axios';

interface Company {
    companyname?: string;
    id?: string;
}

interface Department {
    id: string;
    departmentname: string;
}

interface User {
    email?: string;
}

interface Profile {
    id: string;
    name: string;
    contactno: string;
    usertype?: string;
    Company?: Company;
    Department?: Department;
    user?: User;
}

interface EditMedicalRepModalProps {
    profile: Profile;
    toggleModal: () => void;
}

interface ErrorResponse {
    message?: string;
}

const EditMedicalRepModal: React.FC<EditMedicalRepModalProps> = ({ profile, toggleModal }) => {
    const [formData, setFormData] = useState({
        name: profile?.name || "",
        contactno: profile?.contactno || "",
        company: profile?.Company?.id,
        companyId: profile?.Company?.companyname || "",
        departmentName: profile?.Department?.departmentname || "",  // Store department name directly
        email: profile?.user?.email || "",
        password: "",
        usertype: profile?.usertype || "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");

            const updatedFormData: {
                name: string;
                contactno: string;
                companyId: string;
                email: string;
                password?: string;
            } = {
                name: formData.name,
                contactno: formData.contactno,
                companyId: formData.company ?? "",
                email: formData.email,
            };

            if (formData.password) {
                updatedFormData.password = formData.password;
            }

            await axios.post(`${baseUrl}medicalrep/updatemedicalrep/${profile.id}`, updatedFormData, {
                headers: { Authorization: token || "" },
            });

            toast.success("Profile updated successfully!");
            toggleModal();
            window.location.reload();
        } catch (error) {
            console.error("Error updating profile:", error);

            const axiosError = error as AxiosError<ErrorResponse>;
            if (axiosError.response && axiosError.response.data?.message) {
                toast.error(axiosError.response.data.message);
            } else {
                toast.error("Failed to update profile!");
            }
        }
    };

    return (
        <>
            <Form onSubmit={handleSubmit}>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input type="text" name="name" value={formData.name} onChange={handleChange} required />
                </FormGroup>
                <FormGroup>
                    <Label for="contactno">Contact No</Label>
                    <Input type="text" name="contactno" value={formData.contactno} onChange={handleChange} required />
                </FormGroup>
                <FormGroup>
                    <Label for="companyId">Company</Label>
                    <Input type="text" name="companyId" value={formData.companyId} disabled />
                </FormGroup>
                <FormGroup>
                    <Label for="departmentName">Division</Label>
                    <Input type="text" name="departmentName" value={formData.departmentName} disabled />
                </FormGroup>
                <FormGroup>
                    <Label for="email">Email</Label>
                    <Input type="email" name="email" value={formData.email} onChange={handleChange} required />
                </FormGroup>

                <Button type="submit" color="primary">
                    Update Profile
                </Button>
            </Form>
        </>
    );
};

export default EditMedicalRepModal;
